import AuthService from '../services/auth.service'

import Cookies from 'js-cookie'
import { uniq } from 'lodash'

const user = Cookies.getJSON('intelli:user')
const initialState = user
  ? { status: { loggedIn: true }, user: user, roles: null, permissions: null }
  : { status: { loggedIn: false }, user: null, roles: null, permissions: null }

export const auth = {
  namespaced: true,

  state: initialState,

  actions: {
    async login({ commit }) {
      try {
        const whoiam = await AuthService.whoiam()

        let permissions = []
        for (const role of whoiam.data.roles) {
          permissions = [...permissions, ...role.permissions]
        }

        const permissionsSlug = permissions.map((permission) => {
          return permission.slug
        })

        const uniquePermissions = uniq(permissionsSlug)

        await commit('LOGIN_SUCCESS', {
          user: whoiam.data,
          permissions: uniquePermissions,
          roles: whoiam.data.roles
        })
      } catch (error) {
        console.log(error)
      }
    },

    logout({ commit }) {
      AuthService.logout()
      commit('LOGOUT')
    }
  },

  getters: {
    user(state) {
      return state.user
    },

    roles(state) {
      return state.roles
    },

    permissions(state) {
      return state.permissions
    },

    loggedIn(state) {
      return state.status.loggedIn
    }
  },

  mutations: {
    LOGIN_SUCCESS(state, { user, permissions, roles }) {
      state.status.loggedIn = true
      state.user = user
      state.permissions = permissions
      state.roles = roles
    },

    LOGIN_FAILURE(state) {
      state.status.loggedIn = false
      state.user = null
    },

    LOGOUT(state) {
      state.status.loggedIn = false
      state.user = null
    }
  }
}
